// shop-frontend/src/components/StarRating.jsx
import React from "react";

/**
 * ⭐ Read-only star rating
 * @param {number} value - rating value (0–5)
 * @param {number} size - px size of stars
 */
export default function StarRating({ value = 0, size = 16 }) {
  const v = Math.max(0, Math.min(5, Number(value || 0)));

  return (
    <div style={{ display: "flex", gap: 2, alignItems: "center" }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span
          key={i}
          style={{
            fontSize: size,
            color: i <= v ? "#facc15" : "rgba(255,255,255,0.25)",
            lineHeight: 1,
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
}
